module.exports = __webpack_public_path__ + "img/aquatrol.019652bd.png";